import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { Balance }          from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "BALANCE_LOADING" });
    },

    /**
     * Fetches the Balance List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await Balance.getAll(params);
        data.sort  = params;
        dispatch({ type : "BALANCE_LIST", data });
    },

    /**
     * Fetches a single Balance
     * @param {Function} dispatch
     * @param {Number}   balanceID
     * @returns {Promise}
     */
    async fetchElem(dispatch, balanceID) {
        const data = await Balance.getOne({ balanceID });
        dispatch({ type : "BALANCE_ELEM", data });
    },

    /**
     * Fetches the Balance Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Balance.getEditData();
        dispatch({ type : "BALANCE_EDIT", data });
    },

    /**
     * Edits/Creates a Balance
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Balance.edit(data);
    },

    /**
     * Deletes a Balance
     * @param {Function} dispatch
     * @param {Number}   balanceID
     * @returns {Promise}
     */
    deleteElem(dispatch, balanceID) {
        return Balance.delete({ balanceID });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "BALANCE_LIST", "BALANCE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "BALANCE_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "BALANCE_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "BALANCE_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
            statuses  : action.data.statuses,
        };

    case "BALANCE_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
